// direct_uploads.js

const views = {}

addEventListener("direct-upload:initialize", event => {
  const {target, detail} = event
  const {id, file} = detail

  const form = target.closest('form')
  const submitButton = form?.querySelector('button[type="submit"], input[type="submit"]')

  if (target.dataset.directUploadCustom === "true") {
    const container = target.closest('.direct-upload-container')
    const progress = container.querySelector('.direct-upload-progress')
    const filename = container.querySelector('.direct-upload-filename')

    container.id = `direct-upload-${id}`
    progress.id = `direct-upload-progress-${id}`

    // Reset classes for new upload
    container.classList.remove("direct-upload--complete", "direct-upload--error")
    container.classList.add("direct-upload--pending")

    // Store elements for faster/reliable access
    views[id] = { 
      container, 
      progress, 
      submitButton, 
      originalButtonContent: submitButton?.innerHTML 
    }

    if (filename) filename.textContent = file.name
  } else {
    // Default implementation...
    target.insertAdjacentHTML("beforebegin", `
      <div id="direct-upload-${id}" class="direct-upload direct-upload--pending">
        <div id="direct-upload-progress-${id}" class="direct-upload__progress" style="width: 0%"></div>
        <span class="direct-upload__filename"></span>
      </div>
    `)
    target.previousElementSibling.querySelector(`.direct-upload__filename`).textContent = file.name
    
    views[id] = { submitButton, originalButtonContent: submitButton?.innerHTML }
  }
})

addEventListener("direct-upload:start", event => {
  const {id} = event.detail
  const view = views[id]
  const element = view?.container || document.getElementById(`direct-upload-${id}`)

  if (element) {
    element.classList.remove("direct-upload--pending")
  }
  
  if (view?.submitButton) {
    view.submitButton.disabled = true
    // Optional: Update text to indicate upload started
    // view.submitButton.innerHTML = `<i data-lucide="loader-2" class="w-5 h-5 animate-spin"></i> Uploading...`
    // Note: Re-initializing icons might be needed if using Lucide and changing HTML
  }
})

addEventListener("direct-upload:progress", event => {
  const {id, progress} = event.detail
  const view = views[id]
  const progressElement = view?.progress || document.getElementById(`direct-upload-progress-${id}`)
  
  if (progressElement) {
    progressElement.style.width = `${progress}%`
  }
})

addEventListener("direct-upload:error", event => {
  event.preventDefault()
  const {id, error} = event.detail
  const view = views[id]
  const element = view?.container || document.getElementById(`direct-upload-${id}`)
  
  if (element) {
    element.classList.add("direct-upload--error")
    element.setAttribute("title", error)
  }
  
  if (view?.submitButton) {
    view.submitButton.disabled = false
    if (view.originalButtonContent) {
      view.submitButton.innerHTML = view.originalButtonContent
      // Trigger icon refresh if needed, though usually not needed for restoring exact HTML
      if (window.lucide) window.lucide.createIcons() 
    }
  }
})

addEventListener("direct-upload:end", event => {
  const {id} = event.detail
  const view = views[id]
  const element = view?.container || document.getElementById(`direct-upload-${id}`)
  
  if (element) {
    element.classList.add("direct-upload--complete")
  }
  
  // Note: We typically do NOT re-enable the button here for successful uploads,
  // because the form submission (Turbo/HTML) immediately follows.
  // Enabling it might allow double-submission.
  // However, if the form submission fails separately, Turbo might reset it.
  
  // Clean up view cache
  delete views[id]
})
